import { Endpoint } from '../endpoint';
import { CompanyHolidayId, CompanyHolidayRequest, CompanyHolidayResponse } from '@business/entities/company_holiday';

export function fetchCompanyHolidays() {
  return Endpoint.get<CompanyHolidayResponse[]>(`@gc/company-holidays`);
}

export function createCompanyHoliday(request: CompanyHolidayRequest) {
  return Endpoint.post<CompanyHolidayResponse>(`@gc/company-holidays`, { data: request });
}

export function updateCompanyHoliday(id: CompanyHolidayId, request: CompanyHolidayRequest) {
  return Endpoint.patch<CompanyHolidayResponse>(`@gc/company-holidays/${id}`, { data: request });
}

export function deleteCompanyHoliday(id: CompanyHolidayId) {
  return Endpoint.delete<void>(`@gc/company-holidays/${id}`);
}
